const pageNameKey = "blueprintTableBodyFlexWrapperWithVerifiedIcon";

export const blueprintTableBodyFlexWrapperWithVerifiedIconEn = {
  [pageNameKey]: {
    verifiedIconAltText: "Verified Icon",
  },
};

export const blueprintTableBodyFlexWrapperWithVerifiedIconPtBr = {
  [pageNameKey]: {
    verifiedIconAltText: "Ícone verificado",
  },
};

export const blueprintTableBodyFlexWrapperWithVerifiedIconDe = {
  [pageNameKey]: {
    verifiedIconAltText: "Verifiziert Symbol",
  },
};

export const blueprintTableBodyFlexWrapperWithVerifiedIconZhHans = {
  [pageNameKey]: {
    verifiedIconAltText: "已验证图标",
  },
};

export const blueprintTableBodyFlexWrapperWithVerifiedIconIt = {
  [pageNameKey]: {
    verifiedIconAltText: "Verificato",
  },
};

export const blueprintTableBodyFlexWrapperWithVerifiedIconEs = {
  [pageNameKey]: {
    verifiedIconAltText: "Icono verificado",
  },
};

export const blueprintTableBodyFlexWrapperWithVerifiedIconNl = {
  [pageNameKey]: {
    verifiedIconAltText: "Geverifieerd-pictogram",
  },
};

export const blueprintTableBodyFlexWrapperWithVerifiedIconTr = {
  [pageNameKey]: {
    verifiedIconAltText: "Doğrulanmış Simge",
  },
};
